/**
 * Native app glue (Capacitor), a no-op in the browser:
 *  - Android back button: close a sheet or the offline card, leave the
 *    Station, return to the Planets tab, then send the app to the background.
 *  - Save the moment the app is backgrounded.
 *  - A dark status bar that matches the header.
 */

import { Capacitor } from '@capacitor/core';
import type { AppShell } from './ui/app';

export async function initNative(shell: AppShell, save: () => void): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  const [{ App }, { StatusBar, Style }] = await Promise.all([import('@capacitor/app'), import('@capacitor/status-bar')]);

  void App.addListener('backButton', () => {
    if (!shell.back()) void App.minimizeApp();
  });
  void App.addListener('pause', save);

  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#05080f' });
  } catch {
    // Not every Android version lets the app colour the status bar.
  }
}
